import React from 'react';
import { Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import AuthLayout from '../components/AuthLayout';
import { EmptyState } from '../components/StateBoundary';
import { useSession } from '../viewmodels/SessionViewModel';

/** Signed in, but the account is not linked to an Orka organization yet. */
export default function NotEnabledView() {
  const { signOut } = useSession();
  return (
    <AuthLayout title="Set up your Orka store first">
      <EmptyState
        icon={<LockOutlinedIcon fontSize="large" />}
        title="Your account has no organization yet"
        body="OrkaCrew works with your Orka store. Create a store in Orka, then sign in here again."
        action={<Button onClick={signOut}>Sign out</Button>}
      />
    </AuthLayout>
  );
}
